import { render, staticRenderFns } from "./GroupAddFormIframe.vue?vue&type=template&id=d16b3246&"
import script from "./GroupAddFormIframe.vue?vue&type=script&lang=ts&"
export * from "./GroupAddFormIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports